export default () => {
  const $catalogNav = $('.catalog-nav');

  if ($catalogNav.length === 0) {
    return;
  }

  // $catalogNav.on('click', '.catalog-nav__btn', (e) => {
  //   const $target = $(e.target);
  //   const $catalogNavItem = $target.closest('.catalog-nav__item');

  //   $catalogNavItem.toggleClass('is-active');

  //   $catalogNavItem.find('> .catalog-nav__list').stop().toggle();
  // });

  const $activeItems = $catalogNav.find('.catalog-nav__item.is-active');

  $activeItems.each((index, item) => {
    const $item = $(item);
    const $topLevelParent = $item.closest('.catalog-nav__item--depth-0');

    if ($topLevelParent.length === 0) {
      return;
    }

    $topLevelParent.addClass('is-active');

    const $thirdLevelItem = $topLevelParent.find('.catalog-nav__item--depth-2.is-active');

    if ($thirdLevelItem.length === 0) {
      return;
    }

    $thirdLevelItem.closest('.catalog-nav__item--depth-1').addClass('is-active');
  });
};
